import { render } from "./App.vue?vue&type=template&id=79ef8323"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=79ef8323&lang=css"
script.render = render

export default script